<div class="card bg-card-new card-radius-06 border-0 h-full">
    <div class="card-body">
        <form [formGroup]="form">
            <div class="flex flex-col w-full">
                <div class="w-full section-title mb-1">
                    <h4>Basic info</h4>
                </div>
                <!-- <small class="text-xxs mb-3 opacity-50">Some info may be visible to other people using QETAAT services.</small> -->
                <div class="main-content">

                    <!-- <div class="profile-picture md:mx-auto">
                        <div class="avatar-container">
                            <div class="avatar">
                                <img src="./assets/images/avatars/avatar-3.jpg" alt="">
                            </div>
                            <div class="row-title">
                                <span> Profile picture</span>
                            </div>
                            <div> A Profile picture helps personalize your account</div>
                        </div>
                    </div> -->

                    <div class="profile-form">
                        <div class="profile-row">
                            <div class="row-title">
                                <span> {{'name'|translate}}</span>
                            </div>
                            <div class="row-info">
                                <input type="text" class="row-field" formControlName="name" [placeholder]="'enter_first_name'|translate" #nameIn>
                            </div>
                            <div class="edit-btn">
                                <a (click)="nameIn.focus()" class="cursor-pointer"><mat-icon>edit</mat-icon></a>
                            </div>
                        </div>
                        <div class="profile-row">
                            <div class="row-title">
                                <span> {{'email'|translate}}</span>
                            </div>
                            <div class="row-info">
                                <span>{{userDetails.email}}</span>
                            </div>

                        </div>
                        <div *ngIf="userDetails.company?.en" class="profile-row">
                            <div class="row-title">
                                <span> {{'company'|translate}}</span>
                            </div>
                            <div class="row-info">
                                <span>{{userDetails.company?.en}}</span>
                            </div>

                        </div>
                        <div class="profile-row">
                            <div class="row-title">
                                <span> {{'mobile'|translate}}</span>
                            </div>
                            <div class="row-info">
                                <input type="text" class="row-field" formControlName="mobile" [placeholder]="'mobile'|translate" #mobileIn>
                            </div>
                            <div class="edit-btn no-edit">
                                <a (click)="mobileIn.focus()" class="cursor-pointer"><mat-icon>edit</mat-icon></a>
                            </div>
                        </div>

                        <div *ngIf="!userDetails?.businessInfo" class="profile-row" style="border-bottom: 0;">
                            <div class="row-title">
                                <mat-slide-toggle class="slide-btn" [checked]="businessUser" (change)="onToggle($event)"></mat-slide-toggle>
                            </div>
                            <div class="row-info">
                                <span class="row-field">{{"business_account"|translate}}</span>
                            </div>
                        </div>

                        <div class="actions-row">
                            <button class="btn save-btn" (click)="update()"><span class="mx-2">{{"save"|translate}}</span></button>
                            <button class="btn switch-btn mx-2 change-btn" [disabled]="(!userDetails?.businessInfo)" (click)="changeType()">{{"change_account_type"|translate}}</button>
                            <button class="btn btn-danger" (click)="delete()"><span class="mx-2">{{"delete_account"|translate}}</span></button>

                        </div>
                    </div>

                </div>

            </div>
        </form>
    </div>
</div>
